import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';

import { FromUndergroundTime } from './parts/FromUndergroundTime';
import * as styles from './Underground.css';
// eslint-disable-next-line import/no-restricted-paths
import { IGeoUndergroundInfoSchema } from '../../../node/repositories/newbuilding-card/entities/geo/GeoUndergroundInfoSchema';
import { UndergroundIcon } from '../Underground/parts/UndergroundIcon';

interface IUndergroundsProps {
  underground: IGeoUndergroundInfoSchema[];
  regionId: number | null;
}

export function Undergrounds({ underground, regionId }: IUndergroundsProps) {
  return (
    <>
      {underground.map(undergroundItem => (
        <div key={`${undergroundItem.name}`} className={styles['underground']}>
          {/*Station*/}
          <div className={styles['underground-station']}>
            {undergroundItem.lineColor && <UndergroundIcon lineColor={undergroundItem.lineColor} regionId={regionId} />}
            <InlineText2>{`м. ${undergroundItem.name}`}</InlineText2>
          </div>
          {/*Distance*/}
          <div className={styles['underground-distance']}>
            <FromUndergroundTime timeTransport={undergroundItem.timeTransport} timeWalk={undergroundItem.timeWalk} />
          </div>
        </div>
      ))}
    </>
  );
}
